import React from 'react';
import GameDetailInformation, {
  IGameDetailInformation,
} from '@wearesection/bandai-react-components/organisms/GameDetailInformation';
import Box from '@mui/material/Box';
import {Game} from '~/graphql/types';
import {ComponentPropsAdapter} from '../../types';
import Typography from '@wearesection/bandai-react-components/atoms/Typography';
import Container from '@wearesection/bandai-react-components/atoms/Container';
import {GetRouter} from '~/utils';

type IGameDetailInformationExt = IGameDetailInformation & Game & {};

const adapter: ComponentPropsAdapter<IGameDetailInformationExt, IGameDetailInformation> = data => {
  return {
    title: '',
    listProps: data?.listProps ?? [],
  };
};

const PADDING_COMPONENT: any = {
  '/games': {
    paddingTop: '0px',
    paddingBottom: {
      xs: '72px',
      lg: '40px',
    },
  },
  '/games/[slug]': {
    paddingTop: '0px',
    paddingBottom: {
      xs: '72px',
      lg: '40px',
    },
  },
};

const GameDetailInformationExtOrganisms: React.FC<IGameDetailInformationExt> = props => {
  const componentProps = adapter(props);
  const {copyRight} = props;
  const {pathname} = GetRouter();

  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? PADDING_COMPONENT['/games']}>
      <GameDetailInformation {...componentProps} id={props?.id || ''} />
      <Container>
        <Box
          sx={{
            marginTop: '30px',
            color: '#878787',
            fontFamily: 'Helvetica',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '19px',
          }}
        >
          <Typography
            variant="p8"
            textTransform={'none'}
            sx={{
              maxWidth: {
                xs: '100%',
                md: '100%',
              },
              fontSize: '14px !important',
              wordBreak: 'break-word',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: {
                xs: '6',
                md: '2',
              } /* number of lines to show */,
              lineClamp: {
                xs: '6',
                md: '2',
              },
              WebkitBoxOrient: 'vertical',
            }}
          >
            {`${copyRight} `}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default GameDetailInformationExtOrganisms;
